import FaCategories from '../../pages/Finance/FA/FaCategories/Index';
import AddFaCategory from '../../pages/Finance/FA/FaCategories/AddFaCategory';

//_ Faxid Assets

import HomePage from '../../pages/Finance/FA/FAHome/FAHome';

import FaAssets from '../../pages/Finance/FA/FaAssets/Index';
import AddAssets from '../../pages/Finance/FA/FaAssets/AddAssets';
import AssetsDetails from '../../pages/Finance/FA/FaAssets/AssetsDetails/AssetsDetails';

import FaDepreciation from '../../pages/Finance/FA/FaDepreciation';
import AddDepreciation from '../../pages/Finance/FA/FaDepreciation/Add';
//
import FaRevaluation from '../../pages/Finance/FA/FaRevaluation';
import AddRevaluation from '../../pages/Finance/FA/FaRevaluation/Add';
//
import FaRetirement from '../../pages/Finance/FA/FaRetirement';
import AddRetirement from '../../pages/Finance/FA/FaRetirement/Add';
//
import FaAdjustCost from '../../pages/Finance/FA/FaAdjustCost';
import AddAdjustCost from '../../pages/Finance/FA/FaAdjustCost/Add';
//
//
import FaTransfer from '../../pages/Finance/FA/FaTransfer';
import AddFaTransfer from '../../pages/Finance/FA/FaTransfer/Add';
//
import CreateAccount from '../../pages/Finance/FA/CreateAccount/ListTransactions';
import AccountingPeriod from '../../pages/Finance/Settings/AccountingPeriod/Index';
//
import FaReports from '../../pages/Finance/FA/FaReports/FaReports';
import ReportsBuilder from '../../pages/NTX/Reports/ReportsAllByModule/Reports/ReportsBuilder/ReportsBuilder';

import FaDashboards from '../../pages/Finance/FA/FaDashboards/FaDashboards';
import BuilderDashboard from '../../pages/NTX/DashboardManagament/BuilderDashboard/BuilderDashboard';

const assetsRoutes = [
  {
    path: 'ASSETS',
    children: [
      { path: 'HomePage', element: <HomePage /> },
      //
      { path: 'FaCategories', element: <FaCategories /> },
      { path: 'FaCategories/AddFaCategory', element: <AddFaCategory /> },

      { path: 'FaAssets', element: <FaAssets /> },
      { path: 'FaAssets/AddAssets', element: <AddAssets /> },
      { path: 'FaAssets/:assetsId/AssetsDetails', element: <AssetsDetails /> },

      { path: 'FaDepreciation', element: <FaDepreciation /> },
      { path: 'FaDepreciation/AddDepreciation', element: <AddDepreciation /> },

      { path: 'FaRetirement', element: <FaRetirement /> },
      { path: 'FaRetirement/AddRetirement', element: <AddRetirement /> },

      { path: 'FaRevaluation', element: <FaRevaluation /> },
      { path: 'FaRevaluation/AddRevaluation', element: <AddRevaluation /> },

      { path: 'FaAdjustCost', element: <FaAdjustCost /> },
      { path: 'FaAdjustCost/AddAdjustCost', element: <AddAdjustCost /> },

      { path: 'FaTransfer', element: <FaTransfer /> },
      { path: 'FaTransfer/AddFaTransfer', element: <AddFaTransfer /> },

      { path: 'AccountingPeriod', element: <AccountingPeriod customProp='FA' /> },
      { path: 'CreateAccount', element: <CreateAccount /> },

      { path: 'Reports', element: <FaReports /> },
      { path: 'Reports/:ReportId/ReportsBuilder', element: <ReportsBuilder /> },

      { path: 'Dashboards', element: <FaDashboards /> },
      { path: 'Dashboards/:dashboardId/BuilderDashboard', element: <BuilderDashboard /> }
    ]
  }
];

export default assetsRoutes;
